import api from './apiClient';

// Lambda-backed service for the singleton "home" document
const homeService = {
  async getObjectData() {
    return await api.get('/home');
  },
  async updateObjectData(next) {
    const body = next && typeof next === 'object' ? next : {};
    return await api.put('/home', body);
  },
};

export default homeService;
